// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-submit {
  background-color: #dc3545;
  color: #fff;
  transition: background 0.3s ease-in-out;
}
.btn-submit:hover {
  background-color: #a71d2a;
}`, "",{"version":3,"sources":["webpack://./src/app/features/secure-blockchain/authoring-tools/shared/dialogs/unauthorized-dialog/unauthorized-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,WAAA;EACA,uCAAA;AACF;AACE;EACE,yBAAA;AACJ","sourcesContent":[".btn-submit {\n  background-color: #dc3545; // 🔴 red for unauthorized\n  color: #fff;\n  transition: background 0.3s ease-in-out;\n\n  &:hover {\n    background-color: #a71d2a;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
